import React from 'react';
import {Paper} from 'material-ui';
import PageBuilderSubmit from './form/builder_submit';

class PageBuilderWarning extends React.Component {

    render() {
       
        const {
            page, isDirty, classes, saveButtonLabel, 
            buttonClassName, loading, handlePageSave, 
            handlePageDiscard, handleSetPreview, handlePageClone,
            hasMissingTranslations
        } = this.props;

        return (
            <div>
	            {(isDirty || hasMissingTranslations) && <Paper elevation={2} className={classes.warning}>
                    <PageBuilderSubmit
                        page={page}
                        isDirty={isDirty}
                        classes={classes}
                        saveButtonLabel={saveButtonLabel}
                        buttonClassName={buttonClassName}
                        loading={loading}
                        onSubmit={handlePageSave}
                        onDiscard={handlePageDiscard}
                        onSetPreview={handleSetPreview}
                        onPageClone={handlePageClone}
                        hasMissingTranslations={hasMissingTranslations}
                    />
                </Paper>
	            }
            </div>
        );
    }
}

export default PageBuilderWarning;


// WEBPACK FOOTER //
// ./src/containers/builder/builder_warning.js